package org.multiplatform.kotfolio.pages

import androidx.compose.runtime.*
import com.varabyte.kobweb.compose.css.FontSize
import com.varabyte.kobweb.compose.css.FontWeight
import com.varabyte.kobweb.compose.css.TextAlign
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.ui.*
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.silk.components.text.SpanText
import org.jetbrains.compose.web.css.*
import org.jetbrains.compose.web.dom.Li
import org.jetbrains.compose.web.dom.Ul
import org.multiplatform.kotfolio.components.KotlinCode
import org.multiplatform.kotfolio.layout.BlogLayout
import org.multiplatform.kotfolio.layout.BlogProperties
import org.multiplatform.kotfolio.layout.PageProperties

@Page("wasm_basic")
@Composable
fun BasicWasmPage() {
    BlogLayout(
        PageProperties(
            "WASM",
            ""),
        BlogProperties("Kotlin WASM", "Basic")
    ) {
        Column(horizontalAlignment = Alignment.Start)
        {
            SpanText(
                text = "What is WebAssembly?",
                modifier = Modifier.fontSize(FontSize.Large).padding(top = 2.em)
                    .fontWeight(FontWeight.Bold)
            )

            Ul {
                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "WebAssembly (abbreviated Wasm) is a binary instruction format for a stack-based virtual machine. Wasm is designed as a portable compilation target for programming languages, enabling deployment on the web for client and server applications. This format is platform-independent because it runs on its own virtual machine. Wasm provides Kotlin and other languages with a compilation target to run on the web.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Wasm is the fourth language to the browser bringing better security and performance than JavaScript. It’s an intermediate binary language supported by a growing number of languages as compilation target.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "A Kotlin Native wasm32 LLVM-based compiler target. However, in 2019 they began a rewrite of the feature. In late 2020, they demoed the upcoming version, called “Kotlin/Wasm”. In early 2023, the new version was released as experimental, and required the Wasm runtime to support the then-experimental Wasm-GC proposal. Kotlin Native wasm32 target was deprecated. In late 2023, Wasm-GC was enabled by default in Chrome and Firefox, and Kotlin/Wasm went Alpha.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Kotlin/Wasm compiles your Kotlin code into Wasm format. Using Kotlin/Wasm, you can create applications that run on different environments and devices, which support Wasm and meet Kotlin’s requirements.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }
            }

            SpanText(
                text = "Why Kotlin?",
                modifier = Modifier.fontSize(FontSize.Large).padding(top = 2.em)
                    .fontWeight(FontWeight.Bold)
            )

            Ul {
                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "The Kotlin native compiler uses an LLVM based backend. The same LLVM project is used for WebAssembly. It’s therefore quite easy to target wasm as a compilation target for Kotlin.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }
            }

            SpanText(
                text = "Explain LLVM?",
                modifier = Modifier.fontSize(FontSize.Large).padding(top = 2.em)
                    .fontWeight(FontWeight.Bold)
            )

            Ul {
                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Kotlin Multiplatform uses Kotlin/JVM and Kotlin/Native tools to compile code for multiple platforms. Kotlin/Native is a technology for compiling Kotlin code to native binaries which can run without a virtual machine.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "It is an LLVM based backend for the Kotlin compiler called Konan and native implementation of the Kotlin standard library.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "LLVM is a library that is used to construct, optimize, and produce intermediate and/or binary machine code.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Further, LLVM can be used as a compiler framework, where you provide the “front end” and the “back end” (code that converts LLVM’s representation to actual machine code).",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }
            }

            SpanText(
                text = "WebAssembly Component Model",
                modifier = Modifier.fontSize(FontSize.Large).padding(top = 2.em)
                    .fontWeight(FontWeight.Bold)
            )

            Ul {
                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "The WebAssembly Component Model is an addition to core WebAssembly that addresses shortcomings and streamlines interacting with WebAssembly modules.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Think of the Wasm Component Model as a wrapper around your ”Core” WebAssembly modules",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "WebAssembly allows the execution of low-level CPU instructions, while WASI is a way to model input/output interfaces.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }

               Ul {
                   Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                       SpanText(
                           text = "It defines a canonical ABI which all components adhere to",
                           modifier = Modifier
                               .fontSize(FontSize.Medium)
                       )
                   }

                   Ul {
                       Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                           SpanText(
                               text = "Specifying and standardizing data layout in memory",
                               modifier = Modifier
                                   .fontSize(FontSize.Medium)
                           )
                       }

                       Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                           SpanText(
                               text = "Giving us richer types such as strings, structs, lists",
                               modifier = Modifier
                                   .fontSize(FontSize.Medium)
                           )
                       }

                       Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                           SpanText(
                               text = "We use WebAssembly Interface Type (WIT) as Interface Description Language (IDL) to define contracts.",
                               modifier = Modifier
                                   .fontSize(FontSize.Medium)
                           )
                       }

                       Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                           SpanText(
                               text = "Ultimately, the Wasm Component Model dramatically simplifies using components written in different languages.",
                               modifier = Modifier
                                   .fontSize(FontSize.Medium)
                           )
                       }
                   }
               }
            }

            SpanText(
                text = "WASM Best Open Link",
                modifier = Modifier.fontSize(FontSize.Large).padding(top = 2.em)
                    .fontWeight(FontWeight.Bold)
            )

            Ul {
                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "https://kvision.io/",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }
            }

            KotlinCode(
                code = """
                    fun main() {
                        println(greet())
                    }

                    fun greet() = "World"

                    @JsExport
                    fun welcome(name: String): String = name
                    """.trimIndent()
            )

            SpanText(
                text = "NPM - hammer.js",
                modifier = Modifier.fontSize(FontSize.Large).padding(top = 2.em)
                    .fontWeight(FontWeight.Bold)
            )

            Ul {
                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Hammer is a open-source library that can recognize gestures made by touch, mouse and pointerEvents.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }
            }

            SpanText(
                text = "workbox-webpack-plugin",
                modifier = Modifier.fontSize(FontSize.Large).padding(top = 2.em)
                    .fontWeight(FontWeight.Bold)
            )

            Ul {
                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "The workbox-webpack-plugin is a plugin that helps generate a manifest of local files that workbox-sw should precache during a Webpack build process. It also creates a service worker file and adds it to the webpack asset pipeline. This plugin can be used when precaching files or for simple runtime caching",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }
            }

            SpanText(
                text = "Programmatically Basic ",
                modifier = Modifier.fontSize(FontSize.Large).padding(top = 2.em)
                    .fontWeight(FontWeight.Bold)
            )

            KotlinCode(
                code = """
                    //ForEach 
                    
                    when (state.mode) {
                        ALL -> state.allListIndexed()
                        ACTIVE -> state.activeListIndexed()
                        COMPLETED -> state.completedListIndexed()
                    }.forEach {
                        (index, todo) ->
                        li(className = if (todo.completed) "completed" else null) li@{ }
                    }
                    """.trimIndent()
            )

            KotlinCode(
                code = """
                    class App : Application(), CoroutineScope by CoroutineScope(Dispatchers.Default) {
                        init {
                            //Initialize first time 
                        }
                        
                        override fun start() {
                            //Initialize time API call
                        }
                    }
                    """.trimIndent()
            )

            SpanText(
                text = "textInput",
                modifier = Modifier.fontSize(FontSize.Large).padding(top = 2.em)
                    .fontWeight(FontWeight.Bold)
            )

            KotlinCode(
                code = """
                    textInput(className = "new-todo") {
                        placeholder = "What needs to be done?"
                        autofocus = true
                        onEvent {
                            keydown = { e ->
                                if (e.keyCode == ENTER_KEY) {
                                    self.value //get value
                                    self.value = null //clear value
                                }
                            }
                        }
                    }
                    """.trimIndent()
            )

            SpanText(
                text = "Dropdown Menu",
                modifier = Modifier.fontSize(FontSize.Large).padding(top = 2.em)
                    .fontWeight(FontWeight.Bold)
            )

            KotlinCode(
                code = """
                    div(className = "ui floating dropdown icon button") {
                        i(className = "dropdown icon")
                        div(className = "menu") {
                            div("Select none", className = "item").onClickLaunch {

                            }
                            div("Select visible", className = "item").onClickLaunch {

                            }
                            div("Select all", className = "item").onClickLaunch {

                            }
                        }
                        addAfterInsertHook {
                            @Suppress("UnsafeCastFromDynamic")
                            getElementJQueryD().dropdown()
                        }
                    }
                    """.trimIndent()
            )

            SpanText(
                text = "Divider",
                modifier = Modifier.fontSize(FontSize.Large).padding(top = 2.em)
                    .fontWeight(FontWeight.Bold)
            )

            KotlinCode(
                code = """
                     div(className = "divider")
                    """.trimIndent()
            )

            SpanText(
                text = "Click Handle",
                modifier = Modifier.fontSize(FontSize.Large).padding(top = 2.em)
                    .fontWeight(FontWeight.Bold)
            )

            KotlinCode(
                code = """
                    //dbclick - Double click handle
                    
                     label(todo.title) {
                         onEvent {
                             dblclick = {
                                
                             }
                         }
                     }
                """.trimIndent()
            )
        }
    }
}

//https://github.com/Hey-Deepak/heydeepak.dev
//https://github.com/EfeObus/VwaTek-Apply
//https://github.com/guidoroos/personalwebsite.git
//https://github.com/junjange/junjange.github.io.git
//https://github.com/rajdeepvaghela/AboutMe.git
//https://github.com/iammohdzaki/OneDev.git